import { useState, useEffect } from 'react';

export default function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const navLinks = [
    { label: 'About', id: 'about' },
    { label: 'Services', id: 'services' },
    { label: 'Gallery', id: 'gallery' },
    { label: 'Booking', id: 'booking' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-[#faf8f5]/95 backdrop-blur-sm border-b border-[#e8ddd0]' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="cursor-pointer"
        >
          <h1 className="font-cormorant text-2xl md:text-3xl tracking-widest text-[#2c2218] font-light">
            Bloom<span className="text-[#c4956a]"> Flower</span> Studio
          </h1>
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map(link => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className="font-noto text-sm tracking-widest text-[#6b5c4e] hover:text-[#2c2218] transition-colors cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('booking')}
            className="font-noto text-sm tracking-widest bg-[#2c2218] text-[#faf8f5] px-6 py-2 rounded-full hover:bg-[#c4956a] transition-colors cursor-pointer whitespace-nowrap"
          >
            予約する
          </button>
        </nav>

        {/* Mobile hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-[#2c2218] text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#faf8f5] border-t border-[#e8ddd0] px-6 py-6 flex flex-col gap-4">
          {navLinks.map(link => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className="font-noto text-sm tracking-widest text-[#6b5c4e] text-left cursor-pointer py-2"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('booking')}
            className="font-noto text-sm tracking-widest bg-[#2c2218] text-[#faf8f5] px-6 py-3 rounded-full hover:bg-[#c4956a] transition-colors cursor-pointer whitespace-nowrap text-center mt-2"
          >
            予約する
          </button>
        </div>
      )}
    </header>
  );
}
